<template>
  <div v-if="redModel" class="red-dashboard">
    <ModalWindow v-model:isOpen="isModalOpen">
      <ProductLockCard @cancel="closeModal" @confirm="lockCard" />
    </ModalWindow>
    <ProductBanner
      class="red-dashboard__banner"
      :title="redModel.title"
      :subtitle="redModel.text"
      :info="redModel.additional_text"
    />
    <div class="red-dashboard__content">
      <DashboardAdditionalBanner :redModel="redModel" />
      <CommonTabs
        v-model:tab="activeTab"
        class="red-dashboard__tabs"
        :isLoading="activeTab === 2 && isHistoryLoading"
        :tabs="tabs"
        type="slider"
      >
        <template #tab-item-1>
          <BarButton
            v-for="(item, i) in redModel.action_buttons"
            :key="i"
            :title="item.text"
            :hint="item.hint"
            :iconHead="`i-${item.icon}`"
            :iconTail="`i-${item.class_modificator}`"
            @click="onBtnClick(item)"
          />
        </template>
        <template #tab-item-2>
          <BarButton
            v-for="(item, i) in redModel.info_buttons"
            :key="i"
            :title="item.text"
            :hint="item.hint"
            :iconHead="`i-${item.icon}`"
            :iconTail="`i-${item.class_modificator}`"
            @click="onBtnClick(item)"
          />
        </template>
        <template #tab-item-3>
          <RedHistory
            :visible="activeTab === 2"
            :blocked="!!redModel.red_statement_alert"
            @red-error="onRedHistoryError"
            @loaded="isHistoryLoading = false"
            @loading="isHistoryLoading = true"
          />
        </template>
      </CommonTabs>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { lockCard } from "@/api/dashboard";
import { isInternalLink } from "@/utils/links";
import DashboardAdditionalBanner from "@/components/dashboard/DashboardAdditionalBanner.vue";
import BarButton from "@/components/shared/button/BarButton.vue";
import ProductBanner from "@/components/shared/banner/ProductBanner.vue";
import CommonTabs from "@/components/shared/tab/CommonTabs.vue";
import RedHistory from "@/components/dashboard/history/RedHistory.vue";
import ModalWindow from "@/components/shared/modal/ModalWindow.vue";
import ProductLockCard from "@/components/dashboard/ProductLockCard.vue";
import { checkHasConsent } from "@/api/consent";

export default {
  name: "RedMain",
  components: {
    BarButton,
    ProductBanner,
    CommonTabs,
    RedHistory,
    DashboardAdditionalBanner,
    ModalWindow,
    ProductLockCard,
  },
  data() {
    return {
      isHistoryLoading: true,
      isHistoryBlocked: false,
      simpleId: null,
      isModalOpen: false,
      activeTab: 0,
      tabs: [this.$t`Действия`, this.$t`Инфо`, this.$t`Выписка`],
      consentData: null,
    };
  },
  async created() {
    this.activeTab = parseInt(this.$route.query.tab) || 0;
    this.updateRedModel();
  },
  computed: {
    ...mapGetters({
      redModel: "red/redModel",
    }),
    // TODO: !!!REFACTOR!!!
    btnActions() {
      /*
        Обработка крайних случаев. Не создавайте поле
        если таковых не имеется

        Ключи объекта должны совпадать с полем "name"
        которые записаны в модельке реда (redModel)

        Функции обработчики должны быть стрелочными,
        чтобы сохранить доступ к контексту
        
        Каждый элемент может иметь 3 функции обработчика:
          - click --> При клике на кнопку на главной странице (обязательный)
          - alertRedirect --> При клике на кнопку подтверждения на переход в всплывашке
          - alertClose? --> При клике на кнопку закрытия всплывашки
      */
      return {
        lock_card: {
          click: () => {
            this.$logAnalyticEvent("mybank_red_lock");
            this.openModal();
          },
        },
        prepayment: {
          click: (btn) => {
            if (btn.alert_model) {
              this.onBtnAlert(btn.name, btn.alert_model);
              this.$logAnalyticEvent("mybank_red_prepayment_warn_no_debt");
              return;
            }
            this.$router.push("/bank/red/redPrepayment");
          },
          alertRedirect: (path) => {
            return () => {
              this.$router.push(path || "/bank/red/redrepayment");
            };
          },
        },
        close_red: {
          click: (btn) => {
            this.$logAnalyticEvent("mybank_red_close_clicked");
            if (btn.alert_model) {
              this.onBtnAlert(btn.name, btn.alert_model);
              this.$logAnalyticEvent("mybank_red_close_warn_seen", {
                text: btn.alert_model.title,
              });
              return;
            }
            this.$router.push("/bank/red/close/reason");
          },
          alertRedirect: (path) => {
            return () => {
              if (
                path == "/bank/reroute/red/infoarrest" ||
                path == "/Bank/Red?tab=2"
              ) {
                window.location.href = path;
              } else {
                this.$logAnalyticEvent("mybank_red_close_warn_pick", {
                  answer: "prepayment",
                });
                this.$router.push(path || "/bank/red/redrepayment");
              }
            };
          },
          alertClose: () => {
            this.$logAnalyticEvent("mybank_red_close_warn_pick", {
              answer: "cancel",
            });
          },
        },
        decrease_limit: {
          click: (btn) => {
            this.$logAnalyticEvent("mybank_red_home_reduce_limit_clicked");
            if (btn.alert_model) {
              this.onBtnAlert(btn.name, btn.alert_model);
              this.$logAnalyticEvent("mybank_red_home_reduce_limit_warn_seen", {
                text: btn.alert_model.title,
              });
              return;
            }
            this.$router.push({
              path: btn.link_href,
              query: {
                src: "home",
              },
            });
          },
          alertRedirect: (path) => {
            return () => {
              this.$logAnalyticEvent("mybank_red_home_reduce_limit_warn_pick", {
                answer: "prepayment",
              });
              this.$router.push({
                path: path || "/bank/red/redprepayment",
                query: {
                  fromAlert: true,
                },
              });
            };
          },
          alertClose: () => {
            this.$logAnalyticEvent("mybank_red_home_reduce_limit_warn_pick", {
              answer: "cancel",
            });
          },
        },
        partners: {
          click: (btn) => {
            this.$logAnalyticEvent("mybank_red_partners");
            this.$redirect(btn.link_href);
          },
        },
        inquiries: {
          click: (btn) => {
            if (btn.alert_model) {
              this.onBtnAlert(btn.name, btn.alert_model);
              return;
            }
            this.$logAnalyticEvent("mybank_red_statements_clicked");
            this.$redirect(btn.link_href);
          },
          alertRedirect: (path) => {
            return () => {
              this.$router.push(path);
            };
          },
        },
        increase_limit: {
          click: (btn) => {
            if (btn.alert_model) {
              this.onBtnAlert(btn.name, btn.alert_model);
              this.$logAnalyticEvent("mybank_red_increase_limit_alert_seen");
              return;
            }
            this.checkHasConsent(btn.link_href);
           
          },
          alertRedirect: (path) => {
            return () => {
              this.$router.push(path);
            };
          },
        },
      };
    },
  },
  methods: {
    ...mapActions({
      fetchRedModel: "red/getRedModel",
      showAlert: "system/showAlert",
    }),
    async updateRedModel() {
      try {
        await this.fetchRedModel(!this.redModel);
      } catch {
        if (process.env.VUE_APP_MODE === "production") {
          window.location.href = "/bank";
        }
      }
    },
    onBtnRedirect(srcPath) {
      if (isInternalLink(srcPath)) {
        this.$router.push(srcPath);
      } else {
        window.location = srcPath;
      }
    },
    onBtnAlert(name, alertModel) {
      console.log("showAlet");
      const actions = this.btnActions[name];
      this.$store.dispatch("system/showAlert", {
        title: alertModel.title,
        text: alertModel.text,
        btnCloseText: alertModel.close_button_text,
        btnLinkText: alertModel.button_text,
        btnLink: actions
          ? actions.alertRedirect(alertModel.button_link)
          : alertModel.button_link,
        onHide: actions?.alertClose,
      });
    },
    onBtnClick(btn) {
      if (this.btnActions[btn.name]) {
        this.btnActions[btn.name].click(btn);
        return;
      }
      if (btn.button_type === "link") {
        this.onBtnRedirect(btn.link_href);
      } else {
        this.onBtnAlert(btn.name, btn.alert_model);
      }
    },
    async lockCard() {
      await lockCard(this.simpleId);
      await this.updateRedModel();
      this.showAlert({
        title: this.t`Карта заблокирована`,
      });
      this.closeModal();
    },
    async checkHasConsent(link_href) {
      this.consentData = await checkHasConsent();
      if (this.consentData.is_consent_required) {
        this.$redirect("/bank/red/consent");
        //this.$router.replace("/bank/red/consent");
        return;
      } else{
        this.$redirect(link_href);
      }
    },
    async openModal() {
      if (!this.simpleId) {
        const data = await this.$store.dispatch("bundle/fetchBundle");
        this.simpleId = data.red_products[0].card_product?.simple_id;
      }
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    onRedHistoryError() {
      if (this.redModel.red_statement_alert) {
        const { title, text, close_button_text } =
          this.redModel.red_statement_alert;
        this.showAlert({
          title,
          text,
          btnCloseText: close_button_text,
        });
      }
      this.activeTab = 0;
    },
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(tab) {
        if (tab === 0) {
          this.$logAnalyticEvent("mybank_red_home", {
            page_path: "/bank/red",
          });
        } else if (tab === 1) {
          this.$logAnalyticEvent("mybank_red_info", {
            page_path: "/bank/red",
          });
        } else if (tab === 2) {
          this.$logAnalyticEvent("mybank_red_purchases", {
            page_path: "/bank/red",
          });
        }
        this.$router.replace({
          query: {
            ...this.$route.query,
            tab,
          },
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.red-dashboard {
  font-family: Roboto-Regular;

  &__banner {
    &_subtitle {
      widows: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &__tabs {
    margin-top: 22px;
    background-color: #f0f0f0;
  }
}
</style>
